import Layout from '@/layout/defaultOther';
// 发起的项目
const accounteRouter = {
  path: '/account',
  name: 'account',
  component: Layout,
  children: [
    {
      path: 'payee',
      name: '收款账户',
      meta: {
        promission: {
            'menuName': 'payee'
        }
      },
      component: () => import('@/views/account/payee/index.vue'),
    },
    {
      path: 'invoice',
      name: '发票管理',
      meta: {
        promission: {
            'menuName': 'invoice'
        }
      },
      component: () => import('@/views/account/invoice/index.vue'),
    }
  ],
};

export default accounteRouter;
